export default __webpack_public_path__ + "static/media/Nesha_Laser_0016_Laser_9.fc7c4691.png";